import {z} from '@hono/zod-openapi';

import {VoiceLanguageSchema} from './VoiceLanguageSchema';

export const VoiceDebugSessionCreateRequestSchema = z
  .object({
    schemaVersion: z.literal('1.0.0'),
    profileId: z.string().min(1).max(128).regex(/\S/),
    scenarioId: z.string().min(1).max(128).regex(/\S/),
    scenarioVersion: z.string().min(1).max(64).regex(/\S/),
    idempotencyKey: z.string().min(1).max(128).regex(/\S/),
    // The language the session's VoiceConversation is held in. Omitted, the profile's own
    // language applies — see `FIXTURE_VOICE_DEBUG_PROFILE`.
    language: VoiceLanguageSchema.optional(),
  })
  .strict()
  .openapi('VoiceDebugSessionCreateRequestSchema');

export type VoiceDebugSessionCreateRequest = z.infer<typeof VoiceDebugSessionCreateRequestSchema>;
